import axios from 'axios';
import { API_BASE } from './api';

export const notifyVisit = (page: 'landing' | 'admin' | 'guest', detail: string) => {
  axios.post(`${API_BASE}/notify/visit`, { page, detail }).catch(() => {});
};
